module.exports = __webpack_public_path__ + "img/kosuzu motoori_sc2.8956b82b.png";